<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { authComputed } from '@state/helpers'
import Appmenu from './app-menu'

/**
 * Left sidebar component - contains mainly the application menu
 */
export default {
	components: { VuePerfectScrollbar, Appmenu },
	props: {
		isCondensed: {
			type: Boolean,
			default: true,
		},
		theme: {
			type: String,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
		width: { type: String, required: true },
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
	},
	data() {
		return {
			settings: {
				minScrollbarLength: 60,
			},
		}
	},
	computed: {
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},
	watch: {
		theme: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'dark':
						document.body.classList.add('left-side-menu-dark')
						document.body.classList.remove('left-side-menu-condensed')
						document.body.classList.remove('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-dark')
						break
				}
			}
		},
		type: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'condensed':
						document.body.classList.add('left-side-menu-condensed')
						document.body.classList.remove('left-side-menu-dark')
						document.body.classList.remove('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-condensed')
						break
				}
			}
		},
		width: function(newVal, oldVal) {
			if (newVal !== oldVal) {
				switch (newVal) {
					case 'boxed':
						document.body.classList.add('left-side-menu-condensed')
						document.body.classList.remove('left-side-menu-dark')
						document.body.classList.add('boxed-layout')
						break
					default:
						document.body.classList.remove('left-side-menu-condensed')
						document.body.classList.remove('boxed-layout')
						break
				}
			}
		},
	},
    methods: {
        toggleMenu() {
            this.$parent.toggleMenu()
        },
    },
}
</script>

<template>
	<!-- ========== Left Sidebar Start ========== -->
	<div class="left-side-menu" style="border-right: 1px solid rgba(0, 0, 0, 0.125);">
		<div class="media user-profile mt-2 mb-2" style="border-bottom: 1px solid #eeeeee; padding-top: 15px !important">
			<img
				src="@assets/images/users/avatar-7.jpg"
				class="avatar-sm rounded-circle mr-2"
				alt="Shreyu"
			/>
			<img
				src="@assets/images/users/avatar-7.jpg"
				class="avatar-xs rounded-circle mr-2"
				alt="Shreyu"
			/>
			<div class="media-body">
				<h6 class="pro-user-name mt-0 mb-0">
					{{ session_user_item && session_user_item.profile && session_user_item.profile.name1 ? session_user_item.profile.name1 : '' }}
				</h6>
				<span class="pro-user-desc">
					{{
                        session_user_item && session_user_item.type && session_user_item.type === 'dev' ? 'Разработчик' : ''
                    }}
					{{
                        session_user_item && session_user_item.type && session_user_item.type === 'client' ? 'Пользователь' : ''
                    }}
					{{
                        session_user_item && session_user_item.type && session_user_item.type === 'administrator' ? 'Администратор' : ''
                    }}
					{{
                        session_user_item && session_user_item.type && session_user_item.type === 'partner' ? 'Партнер' : ''
                    }}
				</span>
			</div>

			<b-dropdown variant="black" class="align-self-center padding-0 dropdown" toggle-class="p-0">
				<template v-slot:button-content>
					<feather type="chevron-down" class="align-middle"></feather>
				</template>

                <b-dropdown-item href="/account/profile" class="notify-item">
                    <feather
                        type="user"
                        class="icon-dual icon-xs align-middle"
						style="margin-right: 10px;"
                    ></feather>
                    <span>Мой профиль</span>
                </b-dropdown-item>

				<b-dropdown-item href="/account/settings" class="notify-item">
					<feather
						type="settings"
						class="icon-dual icon-xs align-middle"
						style="margin-right: 10px;"
					></feather>
					<span>Настройки</span>
				</b-dropdown-item>

				<b-dropdown-item href="/logout" class="notify-item">
					<feather
						type="log-out"
						class="icon-dual icon-xs align-middle"
						style="margin-right: 10px;"
					></feather>
					<span>Выход</span>
				</b-dropdown-item>
			</b-dropdown>

		</div>

		<div class="sidebar-content">
			<VuePerfectScrollbar
				v-once
				class="slimscroll-menu"
				:settings="settings"
			>
				<div id="sidebar-menu">
					<Appmenu />
				</div>
			</VuePerfectScrollbar>
		</div>
		<!-- Sidebar -left -->

	</div>
	<!-- Left Sidebar End -->
</template>

<style lang="scss">
    .slimscroll-menu {
        height: 100%;
    }
    .ps > .ps__scrollbar-y-rail {
        width: 8px !important;
        background-color: transparent !important;
    }
    .ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
    .ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
    .ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
    .ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
        width: 6px !important;
    }

    .dropdown-menu.show {
        left: auto;
        right: 0px !important;
    }

    #sidebar-menu > ul > li > a:hover {
        background: none;
        width: calc(100% - 3px);
        border-left: 3px solid #ff8e00;
    }
	
	#sidebar-menu > ul > li > a:hover .menu-arrow {
		right: 27px;
	}
	
	#sidebar-menu > ul > li > a .menu-arrow {
		top: 12px;
	}

    #sidebar-menu > ul > li > a.active {
        background: none;
    }

	.dropdown .dropdown-item {
		padding: 10px 30px 10px 15px
	}

	.dropdown ul li:last-child {
		border-top: 1px solid #eeeeee
	}

	.padding-0 ul{
		padding: 0 !important;
	}	

</style>
